import { formatAppNumber, formatAppWatchTime, formatCompactNumber } from '../format-number';

/**
 * Что за цифры стоят на экране «Статистика публикации» и в каком порядке.
 *
 * Отдельным файлом, потому что экран рисуется дважды: в PDF презентации
 * (insights-screen.ts, поверх jsPDF) и картинкой для Word (insights-canvas.ts,
 * поверх canvas). Расходиться в цифрах эти два экрана не должны, а сами
 * приёмы рисования у них общего не имеют.
 */

export type InsightsData = {
  views: number;
  reach: number;
  likes: number;
  comments: number;
  saved: number;
  shares: number | null;
  reposts: number | null;
  totalInteractions: number | null;
  profileVisits: number | null;
  follows: number | null;
  avgWatchMs: number | null;
  totalWatchMs: number | null;
  skipRate: number | null;
};

export type ScreenKind = 'reel' | 'post';

/** Чего API не отдал — прочерк: это отчёт клиенту, выдумывать нечего. */
const DASH = '—';

/** Плитки «Сводки». Первые три подписи уже на шаблоне, четвёртая у рилса своя. */
export function tileValues(data: InsightsData, kind: ScreenKind): string[] {
  const num = (v: number | null) => (v === null ? DASH : formatAppNumber(v));
  if (kind === 'reel') {
    return [
      num(data.views),
      num(data.reach),
      data.avgWatchMs === null ? DASH : formatAppWatchTime(data.avgWatchMs),
      num(data.totalInteractions),
    ];
  }
  return [num(data.views), num(data.reach), num(data.profileVisits), num(data.follows)];
}

/** Счётчики под превью — в порядке иконок приложения. */
export function counterValues(data: InsightsData): Array<number | null> {
  return [data.likes, data.comments, data.reposts, data.shares, data.saved];
}

/** Счётчик в приложении сокращён: «855», «2,3 тыс.». */
export function counterText(value: number): string {
  return formatCompactNumber(value);
}
